<template>
	<div>
		<h1 class="mt-4 text-center">Coordonnées du {{ services.domiciliation.particulars.quality }}</h1>
		<h2 class="mb-4 text-center">{{ subTitle }}</h2>

		<b-form>
			<!-- Nom -->
			<b-form-group>
				<b-form-row>
					<b-col cols="12" md="6">
						<b-form-group label="Prénom" label-for="first-name" invalid-feedback="Le prénom est obligatoire.">
							<b-input
							id="first-name"
							v-model.trim="$v.particulars.name.firstName.$model"
							:state="validateState($v.particulars.name.firstName)" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="6">
						<b-form-group label="Nom" label-for="last-name" invalid-feedback="Le nom est obligatoire">
							<b-input
							id="last-name"
							v-model.trim="$v.particulars.name.lastName.$model"
							:state="validateState($v.particulars.name.lastName)" />
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>

			<!-- Naissance -->
			<b-form-group>
				<b-form-row>
					<b-col cols="12" md="3">
						<b-form-group
						label="Date de naissance"
						label-for="particulars-birth-day"
						:invalid-feedback="'La date de naissance est obligatoire et doit être au format jj/mm/yyyy.'">
							<b-input
							id="particulars-birth-day"
							v-model.trim="$v.particulars.birth.day.$model"
							:state="validateState($v.particulars.birth.day)"
							@input="setDate($event)" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="9">
						<b-form-group label="A">
							<b-form-row>
								<b-col cols="12" md="5">
									<b-form-group invalid-feedback="Le lieu de naissance est obligatoire">
										<b-input
										placeholder="Ville"
										v-model.trim="$v.particulars.birth.place.city.$model"
										:state="validateState($v.particulars.birth.place.city)" />
									</b-form-group>
								</b-col>

								<b-col cols="12" md="2">
									<b-form-group invalid-feedback="Le code postal est obligatoire, doit être au format numérique et comporter 5 chiffres.">
										<b-input
										placeholder="Code postal"
										v-model.trim="$v.particulars.birth.place.zipCode.$model"
										:state="validateState($v.particulars.birth.place.zipCode)" />
									</b-form-group>
								</b-col>

								<b-col cols="12" md="5">
									<b-form-group invalid-feedback="Le pays de naissance est obligatoire.">
										<b-input
										id="country-of-birth"
										placeholder="Pays"
										list="countriesList"
										v-model.trim="$v.particulars.birth.place.country.$model"
										:state="validateState($v.particulars.birth.place.country)" />

										<b-datalist id="countriesList" :options="countriesList" />
									</b-form-group>
								</b-col>
							</b-form-row>
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>

			<!-- Adresse -->
			<b-form-group>
				<b-form-row>
					<b-col cols="12" md="6">
						<b-form-group label="Adresse" label-for="address" invalid-feedback="L'adresse est obligatoire">
							<b-input
							id="address"
							v-model.trim="$v.particulars.address.place.$model"
							:state="validateState($v.particulars.address.place)" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="2">
						<b-form-group
						label="Code postal"
						label-for="zip-code"
						invalid-feedback="Le code postal est obligatoire, doit être au format numérique et comporter 5 chiffres.">
							<b-input
							id="zip-code"
							v-model.trim="$v.particulars.address.zipCode.$model"
							:state="validateState($v.particulars.address.zipCode)"
							@change="getCitiesByZipCode" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="4">
						<b-form-group label="Ville" label-for="city" invalid-feedback="La ville est obligatoire">
							<b-input
							id="city"
							list="citiesList"
							v-model.trim="$v.particulars.address.city.$model"
							:state="validateState($v.particulars.address.city)" />

							<b-datalist id="citiesList" :options="citiesList" />
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>

			<b-form-row>
				<b-col cols="12" md="6">
					<b-form-group
					label="Téléphone"
					label-for="phone">
						<b-input-group prepend="📞">
							<b-input
							id="phone"
							v-model.trim="$v.particulars.phone.$model"
							aria-describedby="particulars-phone-live-feedback"
							:state="validateState($v.particulars.phone)" />

							<b-form-invalid-feedback id="particulars-phone-live-feedback">
								Le numéro de téléphone est obligatoire, doit être au format numérique et comporter 10 chiffres.
							</b-form-invalid-feedback>
						</b-input-group>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Adresse mail" label-for="mailAddress">
						<b-input-group prepend="@">
							<b-input
							id="mailAddress"
							v-model.trim="$v.particulars.mailAddress.$model"
							aria-describedby="particulars-email-address-live-feedback"
							:state="validateState($v.particulars.mailAddress)" />

							<b-form-invalid-feedback id="particulars-email-address-live-feedback">
								L'adresse mail est obligatoire et doit être au format xxx@xxx.xx
							</b-form-invalid-feedback>
						</b-input-group>
					</b-form-group>
				</b-col>
			</b-form-row>
		</b-form>
  </div>
</template>

<script>
    import { mapState } from 'vuex';

    import axios from 'axios';

    import { required, email, numeric, minLength, maxLength } from "vuelidate/lib/validators";

    export default {
        props: ['clickedNext'],
        data() {
					return {
						mainTitle: `Vos <b>coordonnées</b>`,
						subTitle: "Renseignez vos coordonnées",
						particulars   : {
							name : {
								firstName : null,
								lastName  : null
							},
							birth    : {
								day   : null,
								place : {
									city    : null,
									zipCode : null,
									country : null,
								}
							},
							address  : {
								place   : null,
								zipCode : null,
								city    : null
							},
							phone    : null,
							mailAddress : null
						},
						citiesList    : [],
					};
        },
        validations: {
					particulars: {
						name : {
							firstName : { required },
							lastName  : { required }
						},
						birth: {
							day: {
								required,
								minLength : minLength(10),
								maxLength : maxLength(10)
							},
							place : {
								city: { required },
								zipCode: {
									required,
									numeric,
									minLength: minLength(5),
									maxLength: maxLength(5)
								},
								country: { required },
							}
						},
						address: {
							place: {
								required
							},
							zipCode: {
								required,
								numeric,
								minLength: minLength(5),
								maxLength: maxLength(5)
							},
							city: { required }
						},
						phone: {
							required,
							numeric,
							minLength: minLength(10),
							maxLength: maxLength(10)
						},
						mailAddress: {
							required,
							email
						}
					}
        },
        watch: {
					$v: {
						handler: function(val) {
							if (this.particulars.name.firstName)
								this.particulars.name.firstName = this.particulars.name.firstName.charAt(0).toUpperCase() + this.particulars.name.firstName.substring(1).toLowerCase();

							if (this.particulars.name.lastName)
								this.particulars.name.lastName = this.particulars.name.lastName.toUpperCase();

							this.$store.commit('updateDomiciliationParticulars', { particulars: this.particulars })

							if (!val.$invalid) {
								this.$emit('can-continue', { value: true });
							} else {
								this.$emit('can-continue', { value: false });
							}
						},
						deep: true
					},
					clickedNext() {
						this.$v.$touch();
					}
        },
        methods: {
					getCitiesByZipCode(zipCode) {
						if (zipCode.length === 5) {
							let requestTarget = this.apiDomain + '/get-cities-by-zip-code';

							axios.post(requestTarget, {
								zipCode : zipCode
							})
							.then((response) => {
								let citiesByZipCode = response.data.citiesByZipCode;
								let cities = [];

								citiesByZipCode.forEach((city) => {
									cities.push(city.nomCommune)
								});

								this.citiesList = cities;
							});
						}
					},
					validateState(v) {
						if (!v.$dirty) {
							return null;
						} else {
							return (v.$error) ? false : true
						}
					},
					setDate(event) {
						if (event.length === 2 || event.length === 5) {
							this.particulars.birth.day += '/';
						}
					}
        },
        computed: {
            ...mapState(['services', 'apiDomain', 'countriesList', 'datePicker'])
        }
    };
</script>
